import { render, staticRenderFns } from "./LessonMaterial.vue?vue&type=template&id=3535499e&scoped=true&"
import script from "./LessonMaterial.vue?vue&type=script&lang=js&"
export * from "./LessonMaterial.vue?vue&type=script&lang=js&"
import style0 from "./LessonMaterial.vue?vue&type=style&index=0&id=3535499e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3535499e",
  null
  
)

export default component.exports